import { Component, ReactNode } from "react"

import { VehicleProps } from "./VehicleSlice"

import Year from "../valueAndDate/Year"
import Month from "../valueAndDate/Month"

import Input from "../../libs/ui/inputs/Input"
import Select from "../../libs/ui/inputs/Select"

import { cc50PlateValidation, bikePlateValidation, objectsNamesValidation, numberValidation } from '../../libs/validation/remoteValidationAbstract'
import { OBJECTS_NAMES_PATTERN, NUMBER_PATTERN, isValidTarga } from "../../libs/validation/stringRegex"


interface VeicleStatus {
    size_traga: number
    max_kw: number

    normalizedTarga: string | undefined
    normalizedKw: number | undefined
}

class VehicleManualTyping extends Component<VehicleProps, VeicleStatus> {

    constructor (props: any) {
        super (props)

        const isQudriciclo = (this.props.tipoVeicolo === 'quadriciclo')

        this.state = {
            size_traga: (isQudriciclo) ? 7 : 6,
            max_kw: (isQudriciclo) ? 15 : 6,

            normalizedTarga: this.props.targa,
            normalizedKw: this.props.kw,
        }

        this.updateTipoVeicolo = this.updateTipoVeicolo.bind(this)
        this.updateTarga = this.updateTarga.bind(this)
        this.updateKw = this.updateKw.bind(this)

        this.isValidMicrocarTarga = this.isValidMicrocarTarga.bind(this)
        this.getRemoteValidation = this.getRemoteValidation.bind(this)
    }

    componentDidUpdate(prevProps: Readonly<VehicleProps>, prevState: Readonly<VeicleStatus>, snapshot?: any): void {
        const isQudriciclo = (this.props.tipoVeicolo === 'quadriciclo')
        const sizeTraga = (isQudriciclo) ? 7 : 6
        const maxKw = (isQudriciclo) ? 15 : 6

        let propTraga = this.props.targa
        let propKw = Number(this.props.kw)

        if (
            this.props.tipoVeicolo !== undefined &&
            (
                this.state.size_traga !== sizeTraga ||
                this.state.max_kw !== maxKw
            )
        ) {

            let next = {
                size_traga: sizeTraga,
                max_kw: maxKw
            }

            if (!isQudriciclo) {
                if (propTraga !== undefined && propTraga.length > sizeTraga) {
                    next = {
                        ...next,
                        ...{
                            normalizedTarga: propTraga.substring(0, sizeTraga)
                        }
                    }
                }
                if (!Number.isNaN(propKw) && propKw > maxKw) {
                    next = {
                        ...next,
                        ...{
                            normalizedKw: maxKw
                        }
                    }
                }
            }

            this.setState( next )
        }
    }

    render(): ReactNode {

        return (
            this.props.tipiVeicolo && this.props.tipiAlimentazione &&
            <>

                <Select
                    id='tipo_veicolo' name='tipo_veicolo' key='tipo_veicolo'
                    label='Tipologia del veicolo' 
                    value={this.props.tipoVeicolo}
                    options={this.props.tipiVeicolo}
                    callback={this.updateTipoVeicolo}
                    error={this.props.tipoVeicoloError}
                />
                
                <Input 
                    id='targa' name='targa' key='traga'
                    label='Targa'
                    value={this.state.normalizedTarga}
                    type='text'
                    maxLength={7}
                    callback={this.updateTarga}
                    regexp={this.isValidMicrocarTarga}
                    errorDisplayMsg='Targa non valida'
                    remoteValidation={this.getRemoteValidation}
                    error={this.props.targaError}
                    onInput={
                        (e: any) => 
                            e.currentTarget.value = ((e.currentTarget.value ?? '').length > Number(this.state.size_traga))
                                ? (e.currentTarget.value ?? '').substring (0, this.state.size_traga)
                                : e.currentTarget.value
                    }
                />

                <div className="row">
                    <div className="col-12 col-md-6">
                        <Year 
                            id="anno_immatricolazione"
                            label="Anno immatricolazione"
                            value={this.props.annoImmatricolazione}
                            valueError={this.props.annoImmatricolazioneError}
                            callBack={this.props.updateAnnoImmatricolazioneCallBack}
                            regexp={this.props.regexAnnoImmatricolazione}
                        />
                    </div>
                    <div className="col-12 col-md-6">
                        <Month 
                            id="mese_acquisto"
                            label="Mese Immatricolazione"
                            value={this.props.meseImmatricolazione}
                            valueError={this.props.meseImmatricolazioneError}
                            cutOffYear={this.props.annoImmatricolazione}
                            callBack={this.props.updateMeseImmatricolazioneCallBack}
                            regexp={this.props.regexMeseAcquisto}
                            showOnlyInfuture={true}
                        />
                    </div>
                </div>

                <Year 
                    id="anno_acquisto"
                    label="Anno acquisto"
                    value={this.props.annoAcquisto}
                    valueError={this.props.annoAcquistoError}
                    cutOffYear={this.props.annoImmatricolazione}
                    callBack={this.props.updateAnnoAcquistoCallBack}
                    regexp={this.props.regexAnnoImmatricolazione}
                />

                <Input 
                    id='marca' name='marca' key='marca'
                    label='Marca'
                    value={this.props.marca}
                    type='text'
                    maxLength={50}
                    callback={this.props.updateMarcaCallBack}
                    regexp={OBJECTS_NAMES_PATTERN}
                    errorDisplayMsg='Valore non valido'
                    remoteValidation={objectsNamesValidation}
                    error={this.props.marcaError}
                />

                <Input 
                    id='modello' name='modello' key='modello'
                    label='Modello'
                    value={this.props.modello}
                    type='text'
                    maxLength={64}
                    callback={this.props.updateModelloCallBack}
                    regexp={OBJECTS_NAMES_PATTERN}
                    errorDisplayMsg='Valore non valido'
                    remoteValidation={objectsNamesValidation}
                    error={this.props.modelloError}
                />

                <Input 
                    id='allestimento' name='allestimento' key='allestimento'
                    label='Allestimento'
                    value={this.props.allestimento}
                    type='text'
                    maxLength={100}
                    callback={this.props.updateAllestimentoCallBack}
                    regexp={OBJECTS_NAMES_PATTERN}
                    errorDisplayMsg='Valore non valido'
                    remoteValidation={objectsNamesValidation}
                    error={this.props.allestimentoError}
                />

                <div className="row">
                    <div className="col-12 col-md-6">
                        <Select
                            id='alimentazione' name='alimentazione' key='alimentazione'
                            label='Alimentazione' 
                            value={this.props.alimentazione}
                            options={this.props.tipiAlimentazione}
                            callback={this.props.updateAlimentazioneCallBack}
                            error={this.props.alimentazioneError}
                        />
                    </div>
                    <div className="col-12 col-md-6">
                        <Input
                            id='kw' name='kw' key='kw'
                            label='Kilowatt (kW)'
                            type='number'
                            value={this.state.normalizedKw?.toString()}
                            step='1'
                            min='1'
                            maxLength={2}
                            regexp={NUMBER_PATTERN}
                            remoteValidation={numberValidation}
                            errorDisplayMsg={'Valore non valido'}
                            callback={this.updateKw}
                            error={this.props.kwError}
                            onInput={
                                (e: any) => 
                                    e.currentTarget.value = (Number(e.currentTarget.value ?? '0') > Number(this.state.max_kw))
                                        ? this.state.max_kw
                                        : e.currentTarget.value
                            }
                        />
                    </div>
                </div>

                <Select
                    id='marce' name='marce' key='marce'
                    label='Numero di marce del veicolo' 
                    value={this.props.marce?.toString()}
                    options={ this.props.tipiMarce }
                    callback={this.props.updateMarceCallBack}
                    error={this.props.marceError}
                />
            </>
        )
    }

    private updateTarga (val: string | undefined) {
        this.setState({
            normalizedTarga: val
        }, () => {
            this.props.updateTargaCallBack(val)
        })
    }

    private updateKw (val : number | undefined) {
        this.setState({
            normalizedKw: val
        }, () => {
            this.props.updateKwCallBack (val)
        })
    }

    private updateTipoVeicolo (tipologia : string | undefined) {
        const isQudriciclo = (tipologia === 'quadriciclo')

        this.setState({
            size_traga: (isQudriciclo) ? 7 : 6,
            max_kw: (isQudriciclo) ? 15 : 6,
        }, () => {
            this.props.updateTipoVeicoloCallBack(tipologia)
        })
    }

    private isValidMicrocarTarga (targa: string | undefined) {
        if (targa === undefined || this.props.tipoVeicolo === undefined) {
            return true
        }

        return isValidTarga (
            targa, 
            (this.props.tipoVeicolo === 'quadriciclo') ? 2 : 4
        )
    }

    /**
     * PARTICOLARITA js: 
     * questa funzione ritona la funzione da utilizzare per la validazione remota della targa, 
     * in base alla tipologia di veicolo selezionata
     * 
     * @returns la funzione da usare per la validazione remota di una targa
     */
    private getRemoteValidation (targa: string | undefined) {
        if (targa === undefined || this.props.tipoVeicolo === undefined) {
            return cc50PlateValidation
        }

        return (this.props.tipoVeicolo === 'quadriciclo')
            ? bikePlateValidation
            : cc50PlateValidation
    }
}

export default VehicleManualTyping